import PropTypes from 'prop-types';
export default {
  type: PropTypes.string,
  beds: PropTypes.number,
  baths: PropTypes.number,
  cars: PropTypes.number,
  size: PropTypes.number,
  eer: PropTypes.string
};